import React from 'react'
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import { useMemo } from "react";

const Editor = dynamic(async () => import("../../components/Editor"), {
    ssr: false,
}) as any;

export default function Canvas() {
    const { query } = useRouter();
    const isExportMode = useMemo(() => "exportMode" in query, [query]);

    return (
        <>
            <Editor id="home" showUI={!isExportMode} />
        </>
    )
}
